module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3.02656 10.7485C3.05781 10.7485 3.08906 10.7454 3.12031 10.7407L5.74844 10.2798C5.77969 10.2735 5.80938 10.2595 5.83125 10.236L12.4547 3.6126C12.4692 3.59814 12.4807 3.58097 12.4885 3.56207C12.4963 3.54317 12.5004 3.52291 12.5004 3.50244C12.5004 3.48198 12.4963 3.46171 12.4885 3.44281C12.4807 3.42391 12.4692 3.40674 12.4547 3.39229L9.85781 0.793848C9.82813 0.76416 9.78906 0.748535 9.74688 0.748535C9.70469 0.748535 9.66563 0.76416 9.63594 0.793848L3.0125 7.41729C2.98906 7.44072 2.975 7.46885 2.96875 7.5001L2.50781 10.1282C2.49261 10.2119 2.49804 10.2981 2.52364 10.3792C2.54923 10.4603 2.59421 10.534 2.65469 10.5938C2.75781 10.6938 2.8875 10.7485 3.02656 10.7485ZM4.07969 8.02354L9.74688 2.35791L10.8922 3.50322L5.225 9.16885L3.83594 9.41416L4.07969 8.02354ZM12.75 12.061H1.25C0.973438 12.061 0.75 12.2845 0.75 12.561V13.1235C0.75 13.1923 0.80625 13.2485 0.875 13.2485H13.125C13.1938 13.2485 13.25 13.1923 13.25 13.1235V12.561C13.25 12.2845 13.0266 12.061 12.75 12.061Z",
      "fill": _vm.color || _vm.fillColor
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8b4bb424", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b4bb424"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/Edit.vue
// module id = 1512
// module chunks = 159